export const BANNER_HEIGHT = {
    desktop: {
        collapsed: '224px',
        expanded: '63vh',
    },
    tablet: {
        collapsed: '280px',
        expanded: '80vh',
    },
    mobile: {
        collapsed: '100%',
        expanded: '100vh',
    },
};
export const SHOW_MORE_MAX_LINES = {
    desktop: 4,
    tablet: 5,
    mobile: 12,
};
